import type { FeEmptyArea } from "@/store/useCoverageBetaStore";
import { isEqual } from "lodash";

/**
 * How the QA reviewer changed one area relative to the labeler's submission,
 * for the sidebar badges. lebron recomputes the authoritative diff on submit
 * (`coverage_qa_diff`).
 */
export type QaAreaChange = "added" | "edited" | "deleted";

const productIds = (area: FeEmptyArea) =>
  area.selectedProducts.map((p) => p.id ?? "").sort();

/**
 * `null` when the area is as the labeler left it. An area the labeler had
 * deleted (or never had) that QA brought in counts as added.
 */
export const qaAreaChange = (
  area: FeEmptyArea,
  labelerArea: FeEmptyArea | undefined,
): QaAreaChange | null => {
  const labelerKept = !!labelerArea && !labelerArea.isDeleted;
  if (!labelerKept) return area.isDeleted ? null : "added";
  if (area.isDeleted) return "deleted";
  const edited =
    !isEqual(area.points, labelerArea.points) ||
    !isEqual(productIds(area), productIds(labelerArea));
  return edited ? "edited" : null;
};
